import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic/dinamicApi";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast/toastBaseSlice";
import AlertInterface from "features/toast/toastInterface";

interface RolState {
    status: string;
    error: string;
    rolList: any[],
    rolListActive: any[],
    rol: {
        idRol: number | null;
        nombre: string | null;
        descripcion: string | null;
        estado: number | null;
    }
}

const initialState: RolState = {
    status: 'idle',
    error: '',
    rolList: [],
    rolListActive: [],
    rol: {
        idRol: null,
        nombre: null,
        descripcion: null,
        estado: null
    }
}

export const fetchRol = createAsyncThunk('fetchRol', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 20;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchRolActive = createAsyncThunk('fetchRolActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 3;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyCreateRol = createAsyncThunk('modifyCreateRol', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const rol = selectRol(state);
    const rolAttributes = { ...rol }
    const idsp = rolAttributes.idRol ? 2 : 1;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...rolAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchRol({}));
    return rejectWithValue(message);
});

export const updateEstadoRol = createAsyncThunk('updateEstadoRol', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const rol = selectRol(state);
    const rolAttributes = { ...rol };
    const estado = !rolAttributes.estado;
    const idRol = rolAttributes.idRol;
    const idsp = 4;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, estado, idRol }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    dispatch(setVisible(false));
    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchRol({}));
    return rejectWithValue(message);
});

export const rolSlice = createSlice({
    name: 'rol',
    initialState,
    reducers: {
        setRolList: (state, action) => {
            state.rolList = action.payload;
        },
        setRol: (state, action) => {
            state.rol = !action.payload ? initialState.rol : action.payload;
        },
        resetRol: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(fetchRol.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchRol.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.rolList = data;

            })
            .addCase(fetchRol.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchRolActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchRolActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.rolListActive = data ? data : [];

            })
            .addCase(fetchRolActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(modifyCreateRol.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(modifyCreateRol.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(modifyCreateRol.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(updateEstadoRol.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateEstadoRol.fulfilled, (state, action) => {
                state.status = 'completed';

            })
            .addCase(updateEstadoRol.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    },
});

export const selectStatus = (state: RootState) => state.rol.status;
export const selectError = (state: RootState) => state.rol.error;
export const selectRol = (state: RootState) => state.rol.rol;
export const selectRolList = (state: RootState) => state.rol.rolList;
export const selectRolListActive = (state: RootState) => state.rol.rolListActive;

export const { setRolList, setRol, resetRol } = rolSlice.actions;

export default rolSlice.reducer;
